import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { TextField } from "@material-ui/core";
import dayjs from "dayjs";

export const DatePicker = ({
  label,
  value,
  error,
  required,
  onChange,
  fullWidth,
  variant,
  ...rest
}) => {
  const formatDate = (date) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  };
  const today = new Date().toISOString().substring(0, 10); 
  return (
 
    <TextField
    required={required}
    label={label}
    type="date"
    value={formatDate(value)}//.format("dd/mm/yyyy")}
    // onChange={handleDateChange}
    InputProps={{
      inputProps: { min: today }, // Disable dates before today
      // readOnly: true,
      onKeyDown:(e)=>e.preventDefault()
    }}
    InputLabelProps={{
      shrink: true,
      
    }}
    variant={variant?variant:"outlined"}
    size="small"
    onChange={(e)=>{
      onChange(e.target.value)}}
    fullWidth
    error={error}
    helperText={error}
  />
  );
};
